<script setup lang="ts">
import { router } from '@inertiajs/vue3'
import Dialog from 'primevue/dialog'
import { ref } from 'vue';
import Button from '@/Components/Utils/Button.vue';
import MultiSelect from 'primevue/multiselect'
import Select from 'primevue/select'
import { useTruncate } from '@/Composables/useTruncate';
import { useFormatTime } from '@/Composables/useFormatTime';
import axios from 'axios';
import { notify } from '@kyvg/vue3-notification';
import Icon from '@/Components/Utils/Icon.vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCopyright } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faCopyright)

const props = defineProps<{
    initListSales?: {

    }
    initSelectedSalesId?: number
}>()

const isOpenModal = ref(false)

// Sales
const selectedSalesId = ref(props.initSelectedSalesId || null)
const isLoadingSales = ref(false)
const listSales = ref(props.initListSales || [])
const fetchSales = async () => {
    listSales.value = []
    isLoadingSales.value = true
    try {
        const { data } = await axios.get(route('json.sales'))
        // console.log('dd', data)
        listSales.value = data
        return data
    } catch (error) {
        notify({
            title: 'Oops!',
            text: 'Gagal dalam mencari data sales',
            type: 'error',
        })
    } finally {
        isLoadingSales.value = false
    }
}

// Sales
const selectedOrderId = ref([])
const isLoadingOrder = ref(false)
const listOrder = ref([])
const fetchOrder = async () => {
    isLoadingOrder.value = true
    try {
        const { data } = await axios.get(route('json.orders.status', ['unpaid', selectedSalesId.value]))
        // console.log('data order', data)
        listOrder.value = data
        return data
    } catch (error) {
        console.error('error', error)
        notify({
            title: 'Oops!',
            text: 'Gagal dalam mencari data Order',
            type: 'error',
        })
    } finally {
        isLoadingOrder.value = false
    }
}

// Section: Submit
const isLoadingSubmit = ref(false)
const onSubmitInvoice = () => {
    router.post(
        route('master.invoices.store'),
        {
            // type: selectedInvoiceType.value,
            sales_id: selectedSalesId.value,
            orders: selectedOrderId.value
        },
        {
            onStart: () => isLoadingSubmit.value = true,
            onFinish: () => isLoadingSubmit.value = false,
            onSuccess: () => {
                selectedOrderId.value = []
                selectedSalesId.value = null
                isOpenModal.value = false
            },
            onError: () => notify({
                title: 'Oops!',
                text: 'Gagal dalam membuat invoice',
                type: 'error',
            }),
        }
    )
}
</script>

<template>
    <div>
        <Button label="Buat invoice" @click="isOpenModal = true" icon="fas fa-plus"></Button>
        <Dialog
            v-model:visible="isOpenModal"
            @show="() => fetchSales()"
            modal
            header="Buat Invoice"
            :style="{ width: '30rem' }"
            xdismissableMask
        >
            <!-- Section: Sales -->
            <div class="grid items-center gap-2 mb-4">
                <label for="username" class="font-medium w-24">Sales</label>
                <Select
                    v-model="selectedSalesId"
                    @update:modelValue="() => fetchOrder()"
                    optionLabel="name"
                    :options="listSales"
                    optionValue="id"
                    :disabled="isLoadingSales"
                    :loading="isLoadingSales"
                    filter
                    filterMatchMode="contains"
                    :filterFields="['name', 'role_label']"
                    placeholder="Pilih sales"
                    class="w-full md:w-80"
                >
                    <template #option="slotProps">
                        <div class="">
                            {{ slotProps.option?.name }} <span class="text-gray-400">({{ slotProps.option.role_label }})</span>
                        </div>
                    </template>
                </Select>
            </div>

            <!-- Section: Order -->
            <div class="grid items-center gap-2 mb-4">
                <label for="username" class="font-medium w-24">Order</label>
                <MultiSelect
                    v-model="selectedOrderId"
                    :options="listOrder"
                    optionLabel="reference"
                    optionValue="id"
                    :disabled="!selectedSalesId || isLoadingOrder"
                    :loading="isLoadingOrder"
                    filter
                    filterMatchMode="contains"
                    :filterFields="['reference', 'product.name', 'brand.name', 'sales.name']"
                    placeholder="Pilih order"
                    :maxSelectedLabels="3"
                    class="w-full md:w-80"
                >
                    <template #option="slotProps">
                        <div class="grid">
                            <div>{{ slotProps.option?.reference }} <span class="text-gray-400">({{ useFormatTime(slotProps.option?.created_at) }})</span></div>
                            <div class="text-gray-500">
                                <Icon :data="slotProps.option?.type_icon" />
                                {{ useTruncate(slotProps.option?.product?.name, 15) }}
                                <span v-if="slotProps.option?.brand?.name">| <FontAwesomeIcon icon='fal fa-copyright' class='' fixed-width aria-hidden='true' /> {{ useTruncate(slotProps.option?.brand?.name, 15) }}</span>
                                <!-- {{ slotProps.option?.type_icon }} -->
                            </div>
                        </div>
                    </template>
                </MultiSelect>
            </div>
            
            <div class="flex justify-end gap-2">
                <Button label="Cancel" :style="'tertiary'" @click="isOpenModal = false"></Button>
                <Button label="Save" :disabled="!selectedOrderId.length || isLoadingSales" :loading="isLoadingSubmit" full @click="onSubmitInvoice()"></Button>
            </div>
        </Dialog>
    </div>
</template>